<script>
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Trigger from '../../Models/Trigger';

	let show = false;
	let visible = false;

	function cookies() {
		if (window.gtag)
			window.gtag('consent', 'update', {'analytics_storage': 'granted'});
	}

	function open() {
		show = true;
		visible = true;
	}

	function close() {
		visible = false;
		setTimeout(() => { show = false }, 1000 * 1);
	}

	function deny() {
		Session.updateCookie('deny');
	}

	function allow() {
		Session.updateCookie('allow');
	}

	function init() {
		if (!Helper.app())
			switch ($Session.cookie.status) {
				case 'ask': open(); break;
				case 'allow': cookies(); break;
			}
	}

	Trigger.subscribe('cookie', state => {
		switch (state.status) {
			case 'deny': close(); break;
			case 'allow': close(); cookies(); break;
		}
	});

	init();

</script>

<div class="alert alert-buttons" class:show="{show}" class:visible="{visible}">
	<div class="alert-container">
		<div class="alert-text">
			<i class="fad fa-cookie-bite"></i> Mogen we cookies gebruiken voor onze statistieken?
		</div>
		<div class="alert-button">
			<div class="button" on:click="{event => deny()}">
				<i class="fad fa-times"></i> Liever niet
			</div>
		</div>
		<div class="alert-button" on:click="{event => allow()}">
			<div class="button">
				<i class="fad fa-check"></i> Geen probleem
			</div>
		</div>
	</div>
</div>